import { Building2, ClipboardList, File, FileText, Image, Package, Users } from "lucide-react";
import type { FileRelatedType } from "@bookdental/schemas";

export type FileTagRow = { tag: { id: string; name: string } };

export type FileRow = {
  id: string;
  name: string;
  contentType: string;
  size: number;
  kind: string;
  status: string;
  createdAt: string | Date;
  folderId: string | null;
  tags?: FileTagRow[];
};

export type FolderRow = {
  id: string;
  name: string;
  parentId: string | null;
};

/** Onde o usuário está navegando — pasta manual, lista de entidades de um tipo, ou os arquivos
 *  (agrupados por tag) de UMA entidade específica. */
export type BrowseMode =
  | { kind: "folder"; folderId: string | null }
  | { kind: "entityRoot"; relatedType: FileRelatedType; label: string }
  | { kind: "entity"; relatedType: FileRelatedType; relatedId: string; label: string };

export const FIXED_ENTITY_FOLDERS: Array<{
  relatedType: FileRelatedType;
  label: string;
  icon: typeof Users;
}> = [
  { relatedType: "PATIENT", label: "Pacientes", icon: Users },
  { relatedType: "PARTNER", label: "Parceiros", icon: Building2 },
  { relatedType: "PROSTHESIS_ORDER", label: "Pedidos", icon: ClipboardList },
  { relatedType: "PROSTHESIS_SERVICE", label: "Serviços", icon: Package },
];

export type SortField = "name" | "date" | "size" | "type";
export type SortDirection = "asc" | "desc";

/** Item sendo arrastado pra mover (arquivo ou pasta) — serializado no dataTransfer com um mime
 *  type próprio, pra distinguir de um arraste de arquivo do SO (que usa o tipo nativo "Files"). */
export type DraggedItem = { kind: "arquivo" | "pasta"; id: string; name: string };
export const DRAG_ITEM_MIME = "application/x-bookdental-file-item";

export function compareFiles(a: FileRow, b: FileRow, field: SortField, direction: SortDirection): number {
  let result = 0;
  switch (field) {
    case "name":
      result = a.name.localeCompare(b.name, "pt-BR");
      break;
    case "date":
      result = new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      break;
    case "size":
      result = a.size - b.size;
      break;
    case "type":
      result = a.contentType.localeCompare(b.contentType, "pt-BR");
      break;
  }
  return direction === "desc" ? -result : result;
}

export function fileIconFor(contentType: string): typeof File {
  if (contentType.startsWith("image/")) return Image;
  if (contentType === "application/pdf") return FileText;
  return File;
}
